/*
 * @Descripttion: 出入库 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-03-06
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-03-11 22:38:34
 */

import http from '@/utils/kq/http';

const veHqChurukuApi = {
  //添加接口
  add(data) {
    return http.post(http.service.hq + 'veHqChuruku/add', data);
  },
  //添加接口
  addList(data) {
    return http.post(http.service.hq + 'veHqChuruku/addList', data);
  },
  //删除接口
  delete(ids) {
    return http.delete(http.service.hq + 'veHqChuruku/deleteBatch?ids=' + ids);
  },
  //修改接口
  update(data) {
    return http.put(http.service.hq + 'veHqChuruku/edit', data);
  },
  //分页查询接口
  page(pageData) {
    return http.post(http.service.hq + 'veHqChuruku/page', pageData);
  },
  //分页查询接口
  kcpage(pageData) {
    return http.post(http.service.hq + 'veHqChuruku/kcpage', pageData);
  },
  //查询单个数据接口
  get(id) {
    return http.get(http.service.hq + 'veHqChuruku/queryById', { id: id });
  },
  //更新状态
  updateStatus(data) {
    return http.post(http.service.hq + 'veHqChuruku/updateStatus', data);
  }
};
export default veHqChurukuApi;
